import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson6: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson5"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Daily Habits</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson7"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[6.25rem] text-justify text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Importance of Schedule Maintenance?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>{`In today's fast-paced world, many people find themselves trapped in autopilot mode, going through the motions of their daily lives without conscious awareness of their habits and routines. This lack of mindfulness and presence can have detrimental effects on mental health. `}</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  When we operate on autopilot, we disconnect from the present
                  moment and fail to recognize the impact our daily choices and
                  behaviors have on our well-being. We may engage in unhealthy
                  coping mechanisms, neglect self-care, or overlook
                  opportunities for growth and self-reflection. By awakening to
                  the power of conscious awareness and actively engaging in
                  shaping our daily routines, we can reclaim control over our
                  mental health and foster a more fulfilling and balanced life.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[24.25rem] h-[33.75rem] object-cover"
            alt=""
            src="/7@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>{`Daily Habits & Performance Tracker`}</b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>5AM - 9AM</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Wake Up, Make Bed, Drink 1L of Water, Stretch, Push-ups, Cold
                  Shower, Prayer, Meditation, Reading, Journal
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Work / Study / Trade</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Stretch `}</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>9AM - 1PM</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Full Body Workout / Run</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Break Fast With Fruit</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Work / Study / Trade</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Second Meal - 4 Cooked Eggs</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>1PM - 7PM</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Work / Study</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Workout / Martial Arts / Running / Bike Ride / Swimming / Rock
                  Climbing
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>3rd Big Meal (High Protein)</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>7PM - 10PM</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                No Electrical Devices, Read, Study, Work On To Do List, Cold
                Shower, Prayer, Meditation, Reading, Journal.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>Rules:</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  No Youtube / Television / Social Media / Games During Work
                  Hours
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>No Cigarettes / Drugs</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Walk / Run The Doggos</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Complete All Tasks Every Day</span>
              </span>
            </li>
          </ul>
        </div>
        <b className="self-stretch relative text-[2.81rem] font-nunito text-center">
          Keys to Success
        </b>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b>Consistent Sleep Schedule:</b>
                <span>
                  {" "}
                  Establish a regular sleep schedule by going to bed and waking
                  up at the same time each day. Create a soothing bedtime
                  routine that includes relaxation techniques such as reading a
                  book, taking a warm bath, or practising deep breathing
                  exercises to promote quality sleep.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Balanced Nutrition:</b>
                <span>
                  {" "}
                  Prioritize nourishing your body with a well-balanced diet.
                  Include a variety of fruits, vegetables, whole grains, lean
                  proteins, and healthy fats in your meals. Avoid excessive
                  processed foods, sugary snacks, and caffeine, as they can
                  disrupt your energy levels and mood.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Hydration: `}</b>
                <span>
                  Stay hydrated throughout the day by drinking an adequate
                  amount of water. Keep a water bottle with you as a reminder
                  and make it a habit to sip water regularly. Proper hydration
                  supports brain function, energy levels, and overall
                  well-being.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Regular Physical Activity: `}</b>
                <span>
                  Engage in regular physical activity that suits your fitness
                  level and interests. Find activities you enjoy, such as
                  walking, jogging, dancing, or practising yoga, and aim for at
                  least 30 minutes of moderate exercise most days of the week.
                  Physical activity releases endorphins, improves mood, and
                  boosts overall physical and mental health.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Mindful Eating: `}</b>
                <span>
                  Practice mindful eating by paying attention to your food,
                  savouring each bite, and eating without distractions. Take the
                  time to chew your food thoroughly and appreciate the flavours,
                  textures, and nourishment it provides. Mindful eating helps
                  foster a healthier relationship with food and promotes mindful
                  awareness.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Stress Management:</b>
                <span>
                  {" "}
                  Incorporate stress management techniques into your daily
                  routine. This can include practices such as meditation, deep
                  breathing exercises, progressive muscle relaxation, or
                  engaging in activities that promote relaxation and stress
                  relief, such as taking breaks, listening to calming music, or
                  spending time in nature.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Time for Reflection:</b>
                <span>
                  {" "}
                  Set aside dedicated time for self-reflection and
                  introspection. This can be in the form of journaling,
                  practising gratitude, or engaging in mindfulness exercises.
                  Reflect on your thoughts, emotions, and experiences, and use
                  this time for self-discovery and personal growth.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Social Connections: `}</b>
                <span>
                  Foster meaningful social connections by spending time with
                  loved ones, friends, or engaging in social activities.
                  Schedule regular social interactions, whether through
                  face-to-face meetups, phone calls, or virtual gatherings.
                  Nurturing social connections provides a sense of belonging,
                  support, and fulfilment.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Personal Growth and Learning:</b>
                <span>
                  {" "}
                  Dedicate time for personal growth and learning by engaging in
                  activities that expand your knowledge, skills, and interests.
                  This can involve reading books, attending workshops or
                  webinars, learning a new hobby or language, or pursuing
                  personal development goals.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Relaxation and Leisure:</b>
                <span>
                  {" "}
                  Make time for relaxation and leisure activities that bring you
                  joy and help recharge your energy. Engage in activities such
                  as listening to music, practising hobbies, taking walks in
                  nature, or engaging in creative outlets. Prioritize activities
                  that allow you to unwind, de-stress, and engage in self-care.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Digital Detox: `}</b>
                <span>
                  Allocate dedicated time each day to disconnect from electronic
                  devices and technology. Limit screen time, especially before
                  bed, and engage in activities that promote relaxation and
                  mindfulness instead.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Gratitude Practice: `}</b>
                <span>
                  Cultivate a gratitude practice by expressing appreciation for
                  the positive aspects of your life. Start a gratitude journal,
                  write down three things you're grateful for each day, or share
                  gratitude with others. Focusing on gratitude can shift your
                  mindset and enhance overall well-being.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Mindful Breathing:</b>
                <span>
                  {" "}
                  Incorporate mindful breathing exercises into your routine.
                  Take a few moments throughout the day to focus on your breath,
                  inhaling deeply through your nose and exhaling slowly through
                  your mouth. This simple practice can help reduce stress,
                  increase self-awareness, and promote relaxation.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Setting Intentions:</b>
                <span>
                  {" "}
                  Begin your day by setting positive intentions for how you want
                  to approach the day. Reflect on your values, aspirations, and
                  goals, and consciously choose how you want to show up and
                  engage with the world around you.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Self-Care Rituals:</b>
                <span>
                  {" "}
                  Engage in regular self-care rituals that nourish your mind,
                  body, and soul. This can include activities such as taking a
                  relaxing bath, practising skincare routines, enjoying a cup of
                  tea, or engaging in hobbies that bring you joy and relaxation.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Nature Connection: `}</b>
                <span>
                  Spend time in nature regularly, whether it's a walk in the
                  park, gardening, or simply sitting outdoors. Connecting with
                  nature has numerous mental health benefits, including reducing
                  stress, boosting mood, and promoting a sense of well-being.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Emotional Expression: `}</b>
                <span>
                  Allow yourself to express and process your emotions in a
                  healthy way. Find outlets that work for you, such as
                  journaling, talking to a trusted friend or therapist, or
                  engaging in creative activities like painting or dancing.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Mindful Communication:</b>
                <span>
                  {" "}
                  Practice mindful communication by actively listening to
                  others, being present in conversations, and expressing
                  yourself authentically and compassionately. Cultivating
                  mindful communication can enhance your relationships and
                  create deeper connections.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Reflection and Goal Setting: `}</b>
                <span>
                  Take time to reflect on your personal growth journey and set
                  meaningful goals for the future. Regularly review your
                  progress, adjust your goals if needed, and celebrate your
                  achievements along the way.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <b className="font-dm-sans">{`Flexibility and Adaptability: `}</b>
                <span>
                  Embrace the concept of flexibility and adaptability in your
                  daily routine. Recognize that life is ever-changing, and it's
                  important to adjust your routine to meet your evolving needs
                  and circumstances.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Daily Practices and Habits</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  To cultivate the habit of gratitude and shift your focus
                  towards appreciating what you have, here are some daily
                  practices and habits you can incorporate into your life:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Gratitude journal: `}</b>
                  <span>
                    Set aside a few minutes each day to write down three things
                    you are grateful for. Reflect on the positive aspects of
                    your life, whether it's your relationships, health,
                    achievements, or simple pleasures. This practice trains your
                    mind to notice and appreciate the blessings in your life.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Morning gratitude ritual:</b>
                  <span>
                    {" "}
                    Begin your day by expressing gratitude for the new day
                    ahead. Before getting out of bed, take a moment to think
                    about three things you are grateful for. This sets a
                    positive tone for the day and helps shift your focus towards
                    appreciation from the moment you wake up.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Mindful pauses: `}</b>
                  <span>
                    Throughout your day, take brief mindful pauses to
                    acknowledge and appreciate the present moment. Pause and
                    observe the beauty of nature, savor the taste of your meals,
                    or express gratitude for small acts of kindness from others.
                    These moments of mindfulness deepen your connection to the
                    present and foster a sense of gratitude.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Acts of kindness:</b>
                  <span>
                    {" "}
                    Engage in acts of kindness towards others. It could be as
                    simple as offering a helping hand, expressing appreciation,
                    or actively listening to someone in need. The act of giving
                    and showing kindness not only benefits others but also
                    cultivates a sense of gratitude within yourself.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Reflection before sleep:</b>
                  <span>
                    {" "}
                    Before going to bed, take a few minutes to reflect on your
                    day and identify three positive experiences or moments you
                    are grateful for. This practice helps you end the day on a
                    positive note and reinforces a mindset of gratitude.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Avoid comparison and envy:</b>
                  <span>
                    {" "}
                    Resist the urge to compare yourself to others or covet what
                    they have. Instead, focus on your own journey and the unique
                    blessings in your life. Embrace the understanding that
                    everyone's path is different, and true happiness lies in
                    appreciating your own journey.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Practice mindfulness and presence: `}</b>
                  <span>
                    Train your mind to be fully present in each moment. Engage
                    in mindfulness practices such as meditation, deep breathing
                    exercises, or yoga to cultivate awareness and appreciation
                    for the present moment.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Surround yourself with reminders: `}</b>
                  <span>
                    Place visual reminders of gratitude in your living space,
                    such as inspirational quotes or images that evoke a sense of
                    appreciation. These reminders serve as cues to redirect your
                    attention to gratitude throughout the day.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Remember, cultivating gratitude is a journey that requires
                  consistent effort and practice. As you incorporate these
                  habits into your daily life, you will gradually develop a
                  mindset of appreciation and experience the transformative
                  power of gratitude in fostering genuine happiness.
                </span>
              </span>
            </span>
          </p>
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson7"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson6;
